import moment from "moment";
import { acorisMinBirthDateEndOfYear } from "utils/helpers/date";
import * as yup from "yup";

const validation = (errors) => {
  return yup.object().shape({
    spouse: yup
      .object()
      .shape({
        identity: yup.object().shape({
          user: yup.object().shape({
            birthDate: yup
              .date()
              .typeError(errors.REQUIRED)
              .max(acorisMinBirthDateEndOfYear.toDate(), errors.ACORIS.SPOUSE_AGE)
              .min(
                moment().subtract(100, "year").startOf("year"),
                errors.ACORIS.SPOUSE_AGE,
              )
              .required(errors.REQUIRED),
          }),
          socialRegime: yup
            .string()
            .typeError(errors.REQUIRED)
            .required(errors.REQUIRED),
        }),
      })
      .nullable()
      .default(undefined),
    children: yup.array().of(
      yup.object().shape({
        identity: yup.object().shape({
          user: yup.object().shape({
            birthDate: yup
              .date()
              .typeError(errors.REQUIRED)
              .min(
                moment().subtract(27, "year").startOf("year"),
                errors.ACORIS.CHILD_AGE,
              )
              .max(moment(), errors.ACORIS.CHILD_AGE)
              .required(errors.REQUIRED),
          }),
          socialRegime: yup
            .string()
            .typeError(errors.REQUIRED)
            .required(errors.REQUIRED),
        }),
      }),
    ),
  });
};

export default validation;
